/**
 * The GPS watchdog's pushes (firebase-functions handlers/gpsSilence.ts) as the Cordova app receives them
 * (services/firebase.ts onMessageReceived). The silent `gps-heal` wake starts a heal; the visible "Ubicación sin
 * actualizar" (type gps-health, a gps-silence- tag and sentAt; the "Listo" that closes it has no sentAt) is recorded
 * as seen (arrived with the app open) or opened (tapped). useBackgroundGeolocation records both in the audit
 * (wake_received, notice_seen / notice_opened), docs/plans/2026-10-23-gps-wake-confirmation.md.
 */
export type WatchdogPush =
  | { kind: 'wake'; sentAt: number | null; tripID: string | null }
  | { kind: 'notice'; how: 'seen' | 'opened'; sentAt: number; tag: string }

const num = (v: unknown): number | null => {
  const n = Number(v)
  return v != null && v !== '' && Number.isFinite(n) ? n : null
}

export function watchdogPush(message: any): WatchdogPush | null {
  if (!message) return null
  if (message.messageType === 'data' && message.type === 'gps-heal') {
    return { kind: 'wake', sentAt: num(message.sentAt), tripID: typeof message.tripID === 'string' ? message.tripID : null }
  }
  const tag = message.tag
  const sentAt = num(message.sentAt)
  if (message.messageType === 'notification' && message.type === 'gps-health' && typeof tag === 'string'
      && tag.startsWith('gps-silence-') && sentAt != null) {
    return { kind: 'notice', how: message.tap ? 'opened' : 'seen', sentAt, tag }
  }
  return null
}

// A tap that cold-starts the app arrives before any stream screen listens: kept until one takes it.
let pendingNotice: Extract<WatchdogPush, { kind: 'notice' }> | null = null
export function takePendingNotice() {
  const n = pendingNotice
  pendingNotice = null
  return n
}

/** Hand a watchdog push to the stream (window events). True when the message is consumed (the wake: no banner). */
export function dispatchWatchdogPush(message: any): boolean {
  const push = watchdogPush(message)
  if (!push) return false
  if (push.kind === 'wake') {
    window.dispatchEvent(new CustomEvent('rs:gps-heal', { detail: push }))
    return true
  }
  pendingNotice = push
  window.dispatchEvent(new CustomEvent('rs:gps-notice', { detail: push }))
  return false
}
